import { createFeatureSelector, createSelector } from '@ngrx/store';

import { featureKey, State } from '../reducers/mgm.reducer';

export const selectFeatureState = createFeatureSelector<State>(featureKey);

export const selectMgmConfig = createSelector(selectFeatureState, ({ config }) => config);
export const selectMgmIsActive = createSelector(selectMgmConfig, (config) => config && !!config.isActive);
export const selectVoucherIsActive = createSelector(selectMgmConfig, (config) => config && !!config.voucher);
export const selectVouchersProvider = createSelector(selectFeatureState, ({ config }) => config ? config.vouchers_provider : {});
export const selectMgmConfigLoading = createSelector(selectFeatureState, ({ loading }) => loading);
